t = require('views/internal/teacup-with-helpers')('board_change_background')
getExperiment = require 'lib/experiments/simple-test'

module.exports = t.renderable ({ enabled_customBoardBackgrounds, idMember, upgradeUrl, hasOrganization }) ->
  adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

  t.div '.board-backgrounds-section-tiles.u-clearfix', ->
    t.div '.board-backgrounds-section-tile.board-backgrounds-colors-tile.js-bg-colors', ->
      t.div '.image'
      t.div '.title', ->
        t.format 'colors'
    t.div '.board-backgrounds-section-tile.board-backgrounds-photos-tile.js-bg-photos', ->
      t.div '.image'
      t.div '.title', ->
        t.format 'photos'

  t.hr '.board-menu-header-divider'

  if adsLayoutExperimentEnabled && !enabled_customBoardBackgrounds
    t.div '.background-ads.ads-layout-experiment', =>
      t.div '.ad-header', ->
        t.div '.title', ->
          t.format 'ads-title'
      t.a '.learn-more', { href: '/business-class' }, ->
        t.format 'ads-learn-more'
      t.p '.board-upgrade-button', =>
        if hasOrganization
          t.a '.button.primary.js-upgrade-team', { href: upgradeUrl }, ->
            t.format 'ads-upgrade'
        else
          t.a '.button.primary.js-add-team', { href: '#' }, ->
            t.format 'ads-upgrade'

  t.h2 ->
    t.format 'custom'

  t.div { class: 'board-backgrounds-list u-relative u-clearfix js-custom-list' + if enabled_customBoardBackgrounds then '' else ' disabled' }, ->

    t.div '.board-background-select.board-background-select-upload.js-uploader', ->
      t.form { action: '/1/member/' + idMember + '/customBoardBackgrounds', method: 'post', enctype: 'multipart/form-data' }, ->
        t.input { type: 'hidden', name: 'token', value: '' }
        t.input { type: 'hidden', name: 'format', value: 'http' }
        t.span '.background-box', ->
          t.span '.icon-lg.icon-add'
        t.input '.upload-background.js-upload-image', { type: 'file', name: 'file', multiple: 'multiple', accept: 'image/*' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_change_background.coffee